import { useEventStore } from '@/state/stores/use-event-store';
import ContributorsList from '../contributors-list';

export const ContributorsTab = ({ activateInlineAdding = false }: { activateInlineAdding?: boolean }) => {
  const contributors = useEventStore((s) => s.contributors);
  if (!contributors) return null;
  return <ContributorsList contributors={contributors} activateInlineAdding={activateInlineAdding} />;
};
